<template>
  <section class="text-center my-10">
    <v-progress-circular color="primary"
                         size="50"
                         indeterminate></v-progress-circular>

    <p class="body-2 my-5">{{ message }}</p>
  </section>
</template>

<script>
export default {
  name: 'Loader',
  props: {
    message: {
      type: String,
      required: false,
      default: 'Por favor, espere...'
    }
  }
}
</script>
